module.exports = __webpack_public_path__ + "static/search-func-e44dce93f232374010cbccb20fdc370b.png";